<template>
  <div class="text-xs-center">
    <v-dialog
      style="z-index:10000!important"
      v-model="$store.getters.showUploadLoader"
      persistent
      width="300"
      heigt="200"
    >
      <v-card
        style="position:relative"
        color="primary"
        dark
      >
        <v-card-text class="pt-2">
          <p class="largeFont white--text">Uploading...</p>
          <p class="mt-2">{{$store.getters.uploadFileMessage == '' ? 'Please wait....' : $store.getters.uploadFileMessage}}</p>
          <v-progress-linear
            :value="$store.getters.uploadProgressValue"
            class="mb-0 mt-2"
            buffer-value="100"
            stream
            color="white accent-4"
          ></v-progress-linear>
        </v-card-text>
        <v-card-actions class="pt-0">
          <v-spacer></v-spacer>
          <v-btn color="white" text @click="cancelDownloading">
            Cancel
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  data () {
    return {
      isLoading: true,
      isFullPage: true,
      // message: this.data,
      dialog: true
    }
  },
  methods: {
    cancelDownloading () {
      let source = this.$store.getters.cancelDownloadRequestSource
      source.cancel('Uploading Canceled')
      this.$store.dispatch('SetUploadMessage', '')
      this.$store.dispatch('SetUploadLoader', false)
    }
  }
}
</script>

<style scoped>
.v-overlay {
    z-index: 10000!important;
}
.v-dialog__content {
    z-index: 10002!important;
}
.download_cancel__button {
  position: absolute;
  top: 10px;
  right: 10px;
  color: white;
  font-size: 20px;
}
</style>



// WEBPACK FOOTER //
// src/View/components/fileUploadLoader.vue